
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountProvider"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentAccount"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"extension"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isSamaUser"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isReadOnly"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isDeactivated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hidePortalTutorial"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"portalMfaPhoneNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mfaConfiguredPortalIds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"portalCredentials"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isSystemUser"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"institution"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"faxResponseNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"multiPartyFaxNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"featureFlags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Enrollments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"OptionalSignature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"MultiPartyAuthorization"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pharmacyAndMedicalBenefitFormsEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"skipSendingToPhaxio"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"CareMetxEnrollment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ReferringProvider"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"PortalMFA"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"BenefitsVerification"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"ReferralForms"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pdfURL"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"practicingSpecialty"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emrUploadCategory"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"capturesPatientConsent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"integrations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integrationId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isTop"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"allowedInstitutionIds"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":943}};
    doc.loc.source = {"body":"query AccountProvider {\n  currentAccount {\n    id\n    phone\n    extension\n    firstName\n    lastName\n    isSamaUser\n    isAdmin\n    email\n    isReadOnly\n    isDeactivated\n    hidePortalTutorial\n    portalMfaPhoneNumber\n    mfaConfiguredPortalIds\n    portalCredentials\n    isSystemUser\n\n    institution {\n      name\n      id\n      faxResponseNumber\n      multiPartyFaxNumber\n      featureFlags {\n        Enrollments\n        OptionalSignature\n        MultiPartyAuthorization\n        pharmacyAndMedicalBenefitFormsEnabled\n        skipSendingToPhaxio\n        CareMetxEnrollment\n        ReferringProvider\n        PortalMFA\n        BenefitsVerification\n      }\n      ReferralForms {\n        id\n        title\n        pdfURL\n        description\n      }\n      practicingSpecialty\n      emrUploadCategory\n      capturesPatientConsent\n      integrations {\n        integrationId\n        isEnabled\n      }\n      isTop\n    }\n    allowedInstitutionIds\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["AccountProvider"] = oneQuery(doc, "AccountProvider");
        
